const svgMapDirectory = (element, gsap) => {

  let sectionContainer = element;
  let mapContainer = element.querySelector(".section-container-svg");
  let mapSvg = element.querySelector(".map-svg");
  let tabSelect = element.querySelector(".block-buttons").querySelectorAll(".secondary-button");
  let zoomButtons = element.querySelectorAll('.zoom');
  let fullScreenButton = element.querySelector('.button-full-screen');

  let badge = element.querySelector('#Ion_Badge');
  let badgeParking = element.querySelector('#Parking_Garage_Badge');
  let badgeLabs = element.querySelector('#Greentown_Labs_Badge');
  let badgeWings = element.querySelector('#Stuffd_Wings_Badge');

  let ionBuilding = element.querySelectorAll('g.ion-building');
  let parking = element.querySelectorAll('g.parking');
  let lab = element.querySelectorAll('g.lab');
  let wings = element.querySelectorAll('g.wings');

  let initialZoom = 1;
  const maxZoom = 2;

  // --- Phase map (SVG highlighting) ---

  const phaseMap = mapSvg ? {
    "path-1": mapSvg.querySelector("#Established"),
    "path-2": mapSvg.querySelector("#In_Development"),
    "path-3": mapSvg.querySelector("#Future_Vision"),
  } : {};

  let activeGroup = null;

  const getShapes = (group) => {
    if (!group) return [];
    return group.querySelectorAll("path, polygon, polyline, rect, line, circle, ellipse");
  };

  const getAccentColor = () =>
    window.getComputedStyle(document.documentElement).getPropertyValue("--color-accent");

  const getContrastColor = () =>
    window.getComputedStyle(document.documentElement).getPropertyValue("--color-contrast-text") || "#fff";

  const getEmptyColor = () => "#b6aeae";

  tabSelect.forEach((tab) => {
    tab.addEventListener("click", function () {
      const control = tab.getAttribute("aria-controls");
      const targetGroup = phaseMap[control];

      // Update aria-selected on buttons
      tabSelect.forEach((t) => { t.ariaSelected = "false" });
      tab.ariaSelected = "true";

      // Reset all phases
      Object.values(phaseMap).forEach((group) => {
        if (!group) return;
        group.classList.remove("active");
        gsap.to(getShapes(group), {
          fill: getEmptyColor,
          stroke: "#000",
          duration: 1,
          ease: "back.out(1)",
        });
      });

      // Highlight selected phase
      if (targetGroup) {
        activeGroup = targetGroup;
        targetGroup.classList.add("active");
        gsap.to(getShapes(targetGroup), {
          fill: getAccentColor,
          stroke: getContrastColor(),
          duration: 1,
          ease: "back.out(1)",
        });
      } else {
        activeGroup = null;
      }
    });
  });

  // Paint initial active phase (tab-1 / Established)
  window.addEventListener("load", function () {
    const firstGroup = phaseMap["path-1"];
    if (firstGroup) {
      activeGroup = firstGroup;
      firstGroup.classList.add("active");
      gsap.set(getShapes(firstGroup), { fill: getAccentColor(), stroke: getContrastColor() });
    }
  });

  // --- Zoom in / zoom out ---

  zoomButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      if (button.classList.contains('button-zoom-in')) {
        gsap.to(mapSvg, {
          scale: () => {
            return initialZoom >= maxZoom ? maxZoom : initialZoom += 0.1
          }
        })
        if (initialZoom >= maxZoom) {
          button.setAttribute('disabled', true);
        }
      } else {
        gsap.to(mapSvg, {
          scale: () => {
            return initialZoom <= 1 ? initialZoom : initialZoom -= 0.1
          }
        })
        document.querySelector('.zoom.button-zoom-in').removeAttribute('disabled');
      }
    })
  });

  // --- Panning ---

  mapContainer.addEventListener('mousemove', (e) => {
    if (initialZoom > 1) {
      const { width, height } = mapSvg.getBoundingClientRect();
      const containerWidth = mapContainer.getBoundingClientRect().width;
      const containerHeight = mapContainer.getBoundingClientRect().height;

      const moveOffsetX = (width - containerWidth) / 2;
      const moveOffsetY = (height - containerHeight) / 2;

      const x = e.offsetX - (containerWidth / 2);
      const y = e.offsetY - (containerHeight / 2);

      gsap.to(mapSvg, {
        x: () => {
          if (Math.abs(x) < moveOffsetX) {
            return -x
          }
        },
        y: () => {
          if (Math.abs(y) < moveOffsetY) {
            return -y
          }
        }
      })
    }
  });

  mapContainer.addEventListener('mouseleave', () => {
    gsap.to(mapSvg, { x: 0, y: 0 });
  });

  // --- Fullscreen ---

  fullScreenButton.addEventListener("click", () => {
    sectionContainer.classList.toggle("fullscreen");
  });

  // --- Building badges (hover + click) ---

  function showBadge(el, badge, url) {
    if (!badge) return;
    el.addEventListener('mouseenter', () => { badge.classList.add('show') });
    el.addEventListener('mouseleave', () => { badge.classList.remove('show') });
    el.addEventListener('click', () => { window.location = url });
  }

  ionBuilding.forEach(g => { showBadge(g, badge, '/visit/ion') });

  parking.forEach(g => {
    if (!badgeParking) return;
    g.addEventListener('mouseenter', () => { badgeParking.classList.add('show') });
    g.addEventListener('mouseleave', () => { badgeParking.classList.remove('show') });
  });

  lab.forEach(g => { showBadge(g, badgeLabs, '/tenants/greentown-labs/') });

  wings.forEach(g => { showBadge(g, badgeWings, '/tenants/stuffd-wings') });

};

export { svgMapDirectory };
